module.exports = __webpack_public_path__ + "group_buy/groupbuy_6713-12070cd1b93e6031b13bd519416c3cfb.png";